/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { NotificationList } from '../../models/notification-list';

export interface NotificationControllerGetMyNotifications$Params {
  limit: number;
  skip: number;
}

export function notificationControllerGetMyNotifications(http: HttpClient, rootUrl: string, params: NotificationControllerGetMyNotifications$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: NotificationList;
}>> {
  const rb = new RequestBuilder(rootUrl, notificationControllerGetMyNotifications.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: NotificationList;
      }>;
    })
  );
}

notificationControllerGetMyNotifications.PATH = '/notification';
